var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33342 3.83333C9.33342 5.67167 7.83842 7.16667 6.00008 7.16667C4.16175 7.16667 2.66675 5.67167 2.66675 3.83333C2.66675 1.995 4.16175 0.5 6.00008 0.5C7.83842 0.5 9.33342 1.995 9.33342 3.83333ZM11.8334 14.6667C11.8334 15.1267 11.4609 15.5 11.0001 15.5H1.00008C0.539248 15.5 0.166748 15.1267 0.166748 14.6667C0.166748 11.45 2.78425 8.83333 6.00008 8.83333C9.21592 8.83333 11.8334 11.45 11.8334 14.6667Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIconBlue);
export default __webpack_public_path__ + "static/media/peopleIconBlue.ba95ae17d577c28f77cdcc8b2951402e.svg";
export { ForwardRef as ReactComponent };